import { Message } from 'element-ui'
const tfMessage = function (data) {
  Message.closeAll()
  Message(data)
}
tfMessage.error = function (data) {
  Message.closeAll()
  Message.error(data)
}
tfMessage.success = function (data) {
  Message.closeAll()
  Message.success(data)
}
tfMessage.warning = function (data) {
  Message.closeAll()
  Message.warning(data)
}
export { tfMessage }
